import PartnersSectionCard from './PartnersSectionCard';

export default PartnersSectionCard;